/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Geofence Events Bulk Acknowledge Icon component.
 */
export const AcknowledgeIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 16 13" fill="none">
      <path d="M16 1.77249L5.02857 12.5107L0 7.58904L1.28914 6.3273L5.02857 9.9783L14.7109 0.510742L16 1.77249Z"
        fill={iconColor}
        stroke={iconColor}/>
    </svg>
  );
};
